import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const List = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="list icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M10 3.95569C8.89543 3.95569 8 4.85112 8 5.95569C8 7.06026 8.89543 7.95569 10 7.95569L20 7.95569C21.1046 7.95569 22 7.06026 22 5.95569C22 4.85112 21.1046 3.95569 20 3.95569H10Z"
    />
    <path
      className={pathClass}
      d="M10 9.95569C8.89543 9.95569 8 10.8511 8 11.9557C8 13.0603 8.89543 13.9557 10 13.9557L20 13.9557C21.1046 13.9557 22 13.0603 22 11.9557C22 10.8511 21.1046 9.95569 20 9.95569L10 9.95569Z"
    />
    <path
      className={pathClass}
      d="M8 17.9557C8 16.8511 8.89543 15.9557 10 15.9557L20 15.9557C21.1046 15.9557 22 16.8511 22 17.9557C22 19.0603 21.1046 19.9557 20 19.9557L10 19.9557C8.89543 19.9557 8 19.0603 8 17.9557Z"
    />
    <path
      className={pathClass}
      d="M4 13.9557C5.10457 13.9557 6 13.0603 6 11.9557C6 10.8511 5.10457 9.95569 4 9.95569C2.89543 9.95569 2 10.8511 2 11.9557C2 13.0603 2.89543 13.9557 4 13.9557Z"
    />
    <path
      className={pathClass}
      d="M6 5.95569C6 7.06026 5.10457 7.95569 4 7.95569C2.89543 7.95569 2 7.06026 2 5.95569C2 4.85112 2.89543 3.95569 4 3.95569C5.10457 3.95569 6 4.85112 6 5.95569Z"
    />
    <path
      className={pathClass}
      d="M4 19.9557C5.10457 19.9557 6 19.0603 6 17.9557C6 16.8511 5.10457 15.9557 4 15.9557C2.89543 15.9557 2 16.8511 2 17.9557C2 19.0603 2.89543 19.9557 4 19.9557Z"
    />
  </svg>
)
